import React, { useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import { BackgroundImage, BodyText } from "../../elements";
import { MathUtils } from "../../utils";
import { getOverallSettingsClasses, componentId } from "../../utils/siteUtils";
import "./style.scss";

const Countdown = props => {
  let timeout = null;
  const { fields, rendering } = props;
  const { event_date, event_hour, event_minute, image, title, description, word_day, word_hour, word_minute, word_second, hidden } = fields;
  const [days, setDays] = useState();
  const [hours, setHours] = useState();
  const [minutes, setMinutes] = useState();
  const [seconds, setSeconds] = useState();
  const [visible, setVisible] = useState(hidden ? !hidden.value : true);
  const date = useMemo(() => {
    if (!event_date.value || !event_hour || !event_minute) return null;
    const date = new Date(event_date.value);
    date.setHours(event_hour.fields.phrase.value);
    date.setMinutes(event_minute.fields.phrase.value);
    return date;
  }, []);
  const startCountdown = () => {
    const now = new Date();
    const milliseconds = (date ?? now) - now;
    if (milliseconds > 0) {
      setDays(MathUtils.padding(Math.floor(milliseconds / 1000 / 60 / 60 / 24), 2));
      setHours(MathUtils.padding(Math.floor(milliseconds / 1000 / 60 / 60) % 24, 2));
      setMinutes(MathUtils.padding(Math.floor(milliseconds / 1000 / 60) % 60, 2));
      setSeconds(MathUtils.padding(Math.floor(milliseconds / 1000) % 60, 2));
      timeout = requestAnimationFrame(startCountdown);
    } else {
      setDays("00");
      setHours("00");
      setMinutes("00");
      setSeconds("00");
      setVisible(false);
      timeout = null;
    }
  };
  const stopCountdown = () => {
    if (timeout) {
      cancelAnimationFrame(timeout);
      timeout = null;
    }
  };

  const countdownTitleId = `c-countdown__title_${rendering.uid}`;
  const countdownDescriptionId = `c-countdown__description_${rendering.uid}`;

  useEffect(() => {
    if (date) {
      startCountdown();
    }
    return () => {
      stopCountdown();
    };
  }, []);

  const rootClasses = classNames("c-countdown", getOverallSettingsClasses(fields));
  const rootId = componentId(rendering);
  if (!date) return <div />;
  return (
    <div className={rootClasses} data-source-id={rendering.dataSource} id={rootId}>
      <BackgroundImage {...image} className="c-countdown__content grid">
        <div className="c-countdown__main">
          <BodyText html={description} id={countdownDescriptionId} className="c-countdown__overline" />
          <BodyText html={title} id={countdownTitleId} className="c-countdown__title" />
          {visible && (
            <div className="c-countdown__timer">
              <div className="c-countdown__timer-item">
                <p className="c-countdown__timer-data">{days}</p>
                <p className="c-countdown__timer-unit">{word_day?.value || "天"}</p>
              </div>
              <div className="c-countdown__timer-item">
                <p className="c-countdown__timer-data">{hours}</p>
                <p className="c-countdown__timer-unit">{word_hour?.value || "小时"}</p>
              </div>
              <div className="c-countdown__timer-item">
                <p className="c-countdown__timer-data">{minutes}</p>
                <p className="c-countdown__timer-unit">{word_minute?.value || "分钟"}</p>
              </div>
              <div className="c-countdown__timer-item">
                <p className="c-countdown__timer-data">{seconds}</p>
                <p className="c-countdown__timer-unit">{word_second?.value || "秒"}</p>
              </div>
            </div>
          )}
        </div>
      </BackgroundImage>
    </div>
  );
};
export default Countdown;
